export default __webpack_public_path__ + "static/media/Word-personaje-03.42da479a.png";